<template>
  <div class="flex flex-col justify-center items-start px-[16px] pt-[24px] md:p-0 md:mt-[60px] max-w-[450px] mx-auto">
    <h1 class="text-left text-[25px] md:text-[32px]">Share your progress with our clinicians</h1>
    <div class="mt-[14px] md:mt-[26px] text-left w-full">
      We need to ask you a few questions to understand if your treatment is working.
      <br />
      This should only take a couple of minutes.
    </div>

    <button
      class="mt-[16px] md:mt-[26px] h-[70px] text-[18px] font-medium w-full md:w-[414px] primary-btn"
      v-on:click="start()"
    >
      <div class="flex justify-center items-center">
        <span>Get started</span>
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    start: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
});
</script>

<style scoped>
@tailwind utilities;
@tailwind components;
</style>
